module.exports = __webpack_public_path__ + "public/images/cooking.19b42f96c937eac81b6223f4e589c85c.png";